module.exports = __webpack_public_path__ + "static/media/blueCircleEditIcon.4a6ea2e4.svg";